import React, { useEffect, useState } from 'react';
import { leadership as mockLeadership } from '../../mock';
import { useLang } from '../../i18n/LanguageContext';
import { api } from '../../services/api';

const LeadershipGrid = () => {
  const { t, tv } = useLang();
  const [list, setList] = useState(mockLeadership);

  useEffect(() => {
    api.listLeadership().then((d) => { if (d && d.length) setList(d); }).catch(() => {});
  }, []);

  return (
    <section className="bg-[#f5f5f5] py-16">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-10">
          <div className="h-[3px] w-16 bg-[#d4a017] mx-auto mb-4" />
          <h2 className="text-4xl md:text-5xl font-bold text-[#0a1929] tracking-wide" style={{ fontFamily: "'Roboto Condensed', sans-serif" }}>
            {t('foundationLeadership')}
          </h2>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {list.slice(0, 4).map((p, i) => (
            <a key={p.id || p.name} href="/pimpinan" className="group block bg-white shadow-md hover:shadow-xl transition overflow-hidden">
              <div className="relative aspect-[3/4] overflow-hidden bg-[#0a1929]">
                <img src={p.image} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition duration-500" style={{ filter: 'brightness(0.95)' }} />
                <div className="absolute top-3 left-3 bg-[#d4a017] text-[#0a1929] text-[10px] font-bold px-2 py-1 tracking-widest">0{i + 1}</div>
              </div>
              <div className="p-4 border-t-4 border-[#0a1929] group-hover:border-[#d4a017] transition">
                <h3 className="text-[#0a1929] font-bold text-base md:text-lg leading-tight mb-1" style={{ fontFamily: "'Roboto Condensed', sans-serif" }}>{p.name}</h3>
                <p className="text-gray-600 text-xs md:text-sm uppercase tracking-wide">{tv(p.title)}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LeadershipGrid;
